<template>
  <div class="w-full">
    <custom-automation-node
      :data="data"
      color="#CD0404"
      icon="pi-clock"
      :title="title "
      node-type="middle"
      @remove="remove"
    >
      <div class="flex flex-col w-full gap-2 mt-4 bg-gray-200 rounded-lg p-3">
        <span class="font-medium">לאחר כמה ימים מהתור לבצע את הפעולה?</span>
        <div class="flex gap-2 w-full justify-center items-center">
          <InputNumber
            class="w-full mb-0"
            v-model="afterAmountOfDays"
          />
          <span
            class="bg-gray-300 px-2 mb-2 h-12 ml-3 rounded-xl flex justify-center items-center border border-solid border-gray-400"
            @click="updateAmountOfDays">
          שמירה
        </span>
        </div>
      </div>
    </custom-automation-node>
  </div>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from 'vue';

const props = defineProps({
  data: {
    type: Object as PropType<Record<string, any>>,
    required: false
  }
});
const emit = defineEmits(['remove', 'update-amount-of-days']);

const afterAmountOfDays = ref<number>(props.data?.additionalParams?.days);

const title = computed(() => {
  console.log(afterAmountOfDays);
  return `עברו ${Number.isFinite(afterAmountOfDays.value) ? afterAmountOfDays.value : 'X'} ימים מהתור`;
});

const remove = () => {
  emit('remove');
};

const updateAmountOfDays = () => {
  console.log('afterAmountOfDays emit', afterAmountOfDays);
  emit('update-amount-of-days', afterAmountOfDays.value);
};
</script>

<style scoped>

</style>
